import React from 'react'
import ReactDOM from 'react-dom'
import { useSpring, animated } from 'react-spring'
import Cards9 from "./Cards_9";
import { NavLink, Link } from "react-router-dom";

const calc = (x, y) => [-(y - window.innerHeight / 2) / 20, (x - window.innerWidth / 2) / 20, 1.1]
const trans = (x, y, s) => `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`

/*<div className="">
<animated.div
        class="card3"
        onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
        onMouseLeave={() => set({ xys: [0, 0, 1] })}
        style={{ transform: props.xys.interpolate(trans) , backgroundImage:  'url("./pictures/images_9.jpg")' }}    
/> 

</div>*/



function Card() {
  const [props, set] = useSpring(() => ({ xys: [0, 0, 1], config: { mass: 5, tension: 350, friction: 40 } }))

  var divStyle = {
    color: 'blue',
    cursor: 'pointer',
  }
  
  return (
        <div className="">


        <div   id = "signal-report"    className="card-3" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}   >
        <br></br>
        <a     id ="Strategy" aria-expanded="false"   ><img  width="170px" height="70px" src="./pictures/images_10.jpg"></img><span className="doc-content-title">US stocks, CFDs and Cryptocurrencies Picks</span></a>
                          <div className="wrapper_line"></div>

                          <br></br>

                <p id="page_summary_id" className="page_summary_id">
                <span>Our proprietary system continuously gathers and processes the datasets required for the calibration and optimization of its underlying analytical engines. </span>
                <span>Selected financial instruments ( US stocks, CFDs stocks and Cryptocurrencies )  are dynamically filtered based on historical behavioral records, focusing primarily on highly liquid and volatile market opportunities that present favorable trading conditions. </span>

                  <br></br>  
                  <br></br>  

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                  >
                    Learn more ...
                  </NavLink>
                
                  <br></br>  
               
                </p>

                <br></br>
                  <Cards9 />
                  <br></br>
        </div>
        </div>

  )
};

export default Card; 


